import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { GridLayerDTO, LayerDTO, LayerTypeDTO } from 'business/models/Models';
import { getIngredient } from 'business/plateviewer/Generate/GenerateCommon';
import { getLinkedLayerGridDto } from 'business/plateviewer/GenerateUtil';
import {
  getIngIngType,
  getIngredientStock,
  getIngredientType,
  getVaryAlongName,
} from 'utils/Global';
import { TABLE_LAYOUT } from './ExperimentReportPDF';

export function gridLayerDetailSubReport(content: any[], expData: ExperimentDtoClient) {
  const gridLayers = expData.layers.filter((lyr) => lyr.type === LayerTypeDTO.Grid);
  gridLayers.forEach((layer) => {
    const lyrDetail = layer.layerDetail as GridLayerDTO;
    content.push({
      text:
        '\n' + layer.name + ' - ' + (layer.height + 1) + ' x ' + (layer.width + 1) + '\n',
      style: 'largeText',
    });
    content.push(getGridLayerDetailTable(lyrDetail, gridLayers));
  });
}

function getGridLayerDetailTable(lyrDetail: GridLayerDTO, layers: LayerDTO[]) {
  const body: any = [
    [
      { text: 'Type', bold: true },
      { text: 'Ingredient', bold: true },
      { text: 'Stock Conc.', bold: true },
      { text: 'Stock Low pH', bold: true },
      { text: 'Stock High pH', bold: true },
      { text: 'Conc. Vary Along', bold: true },
      { text: 'Start Conc.', bold: true },
      { text: 'Stop Conc.', bold: true },
      { text: 'pH Vary Along', bold: true },
      { text: 'Start pH', bold: true },
      { text: 'Stop pH', bold: true },
    ],
  ];
  const gridDTO =
    lyrDetail.subGridNumber == 1
      ? lyrDetail.grid
      : getLinkedLayerGridDto(layers, lyrDetail);
  gridDTO.gridIngredient.forEach((ing) => {
    const ingIngType = getIngIngType(ing.ingredientIngredientTypeId);
    const ingType = getIngredientType(ingIngType.ingredientTypeId);
    const ingredient = getIngredient(ingIngType.ingredientId);
    const ingStock = getIngredientStock(ing.ingredientStockId);
    const highPhIngStock = getIngredientStock(ing.highPhingredientStockId);
    body.push([
      ingType.name,
      ingredient.longName,
      ingStock.stockConcentration,
      ingStock.isBuffer ? ingStock.stockPh : '',
      ingStock.isBuffer && highPhIngStock ? highPhIngStock.stockPh : '',
      getVaryAlongName(ing.concentrationVaryAlong),
      ing.startConcentration,
      ing.stopConcentration,
      getVaryAlongName(ing.pHvaryAlong),
      ing.startpH ? ing.startpH : '',
      ing.stoppH ? ing.stoppH : '',
    ]);
  });

  return {
    table: {
      widths: ['15%', '25%', '8%', '6%', '6%', '8%', '6%', '6%', '8%', '6%', '6%'],
      headerRows: 1,
      body: body,
    },
    layout: TABLE_LAYOUT,
  };
}
